import { useEffect, useCallback, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const useSearchBar = ({ 
    searchOptions, 
    searchQuery, 
    setSearchQuery = () => {},
    handleSearchClick, 
    getData,
    sortBy, 
    setpageNumber 
}) => {
    const { t } = useTranslation();
    const location = useLocation();
    const previousPathRef = useRef(location.pathname);

    // Reset search only when route changes (not on mount/unmount).
    useEffect(() => {
        if (previousPathRef.current !== location.pathname) {
            previousPathRef.current = location.pathname;
            if (typeof setSearchQuery === 'function') {
                setSearchQuery({});
            }
        }
    }, [location.pathname, setSearchQuery]);

    const getPlaceholder = useCallback(() => {
        return t('common.search');
    }, [t]);

    const onSearchClick = useCallback(() => {
        if (typeof handleSearchClick === 'function' && typeof getData === 'function') {
            handleSearchClick(getData, { 
                searchQuery, 
                sortBy, 
                sortDir: 'asc' 
            });
        }
    }, [getData, handleSearchClick, searchQuery, sortBy]);

    const handleSearchChange = useCallback((e) => {
        if (typeof setSearchQuery !== 'function') return;
        
        const { name, value } = e.target;
        setSearchQuery(prev => ({
            ...prev,
            [name]: value
        }));
    }, [setSearchQuery]);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            onSearchClick();
        }
    }, [onSearchClick]);

    return {
        handleSearchChange,
        handleKeyDown,
        onSearchClick,
        getPlaceholder
    };
};